import { defineStore } from 'pinia';
import { store } from '/@/store';
import {
  CurrencyType,
  TradingAccountListItem,
  WalletType,
} from '/@/api/exchangeService/model/tradingAccount';
import { tradingAccountAllApi, tradingAccountSearchApi } from '/@/api/exchangeService';
import numeral from 'numeral';
import dayjs from 'dayjs';
interface AccountState {
  accountList: TradingAccountListItem[];
  currentAccount: TradingAccountListItem | null;
  needFresh: boolean;
  currency: CurrencyType;
}
interface queryParamsType {
  pageNo: number;
  pageSize: number;
  currency?: string;
}
export const useAccountInfosStore = defineStore({
  id: 'account-infos',
  state: (): AccountState => ({
    // 账户列表
    accountList: [],
    currentAccount: null,
    currency: 'RMB',
    needFresh: true,
  }),
  getters: {
    /**
     * 已过滤掉没有资金账号的数据
     * @returns
     */
    getAccountList(): TradingAccountListItem[] {
      return this.accountList.filter((item) => !!item.fundAccountCode);
    },
    /**
     * 获取当前账户
     * 根据币种过滤
     */
    getCurrentWallet(): WalletType | undefined {
      return this.currentAccount?.wallets?.find?.((item) => item.currency === this.currency);
    },
    /**
     * 获取当前账户资金余额
     */
    getAccountBalanceOrigin(): number {
      const res = this.currentAccount?.availableBalance || 0;
      return res;
    },
    /**
     * 获取当前账户资金余额 格式化
     */
    getAccountBalance(): string {
      const res = this.currentAccount?.availableBalance || 0;
      return numeral(res).format('0,0.00');
    },
    /** 获取用于资金分配的列表 */
    getAllocationList(): TradingAccountListItem[] {
      // 过滤当前账户
      const res = this.getAccountList.filter(
        (item) => item.tradingAccountCode !== this.currentAccount?.tradingAccountCode,
      );
      const list = JSON.parse(JSON.stringify(res));
      // 遍历列表，设置资金分配
      list.forEach((item) => {
        // 初始化资金分配金额
        if (!item.allocation) {
          item.allocation = null;
        }
      });
      return list;
    },
    /**
     * 获取当前账户资金更新时间
     */
    getAccountUpdateTime(): string {
      const res = this.currentAccount?.updateTime;
      return dayjs(res).format('YYYY-MM-DD HH:mm');
    },
  },
  actions: {
    setCurrentAccount(account: TradingAccountListItem) {
      this.currentAccount = account;
    },
    setCurrency(currency: CurrencyType) {
      this.currency = currency;
    },
    /**
     *
     * @param flag 是否需要刷新
     */
    setNeedFresh(flag: boolean) {
      this.needFresh = flag;
    },
    async fetchAccoutList(simple = false, currencyParams) {
      const queryParams: queryParamsType = {
        pageNo: 1,
        pageSize: 100,
      };
      // 如果需要根据币种过滤
      if (currencyParams) {
        queryParams.currency = currencyParams.currency;
      }
      const res = simple
        ? await tradingAccountAllApi(queryParams)
        : await tradingAccountSearchApi(queryParams);
      this.accountList = res.list;
      return this.accountList;
    },
    changeRecord(obj, index: number) {
      this.accountList[index] = {
        ...this.accountList[index],
        ...obj,
      };
    },
  },
});

// Need to be used outside the setup
export function useAccountInfosStoreWithOut() {
  return useAccountInfosStore(store);
}
